import { BaseItemStore } from "../../core/BaseStore";
import type BaseModuleModel from "./BaseModuleModel";
import type { ModuleModelData, Snapshot } from "./BaseModuleModel";

export default class ModulesStore extends BaseItemStore<
  BaseModuleModel<Snapshot, ModuleModelData<Snapshot>>
> {}
